<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Employee Summary Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <!-- Filters Row 1 - horizontal like Joining Report -->
                <v-row class="py-1" style="margin-bottom: -22px;">
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.department_id" :items="departments" :item-title="(item) => `${item.name}`" item-value="id" label="Department" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-office-building" />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.designation_id" :items="designations" :item-title="(item) => `${item.name}`" item-value="id" label="Designation" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-badge-account" />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.employee_type_id" :items="employeeTypes" :item-title="(item) => `${item.name}`" item-value="id" label="Employee Type" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-account-tie" />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.section_id" :items="sections" :item-title="(item) => `${item.name}`" item-value="id" label="Section" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-view-list-outline" />
                  </v-col>
                </v-row>

                <!-- Filters Row 2 - additional filters -->
                <v-row class="py-0" style="margin-top: -8px;">
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.gender_id" :items="genders" :item-title="(item) => `${item.name}`" item-value="id" label="Gender" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-gender-male-female" />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.religion_id" :items="religions" :item-title="(item) => `${item.name}`" item-value="id" label="Religion" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-hands-pray" />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.blood_group_id" :items="bloodGroups" :item-title="(item) => `${item.name}`" item-value="id" label="Blood Group" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-blood-bag" />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-autocomplete v-model="filters.marital_status_id" :items="maritalStatuses" :item-title="(item) => `${item.name}`" item-value="id" label="Marital Status" variant="outlined" density="compact" bg-color="grey-lighten-4" clearable prepend-inner-icon="mdi-ring" />
                  </v-col>
                </v-row>

                <!-- Filters Row 3 - dates and actions like Joining Report -->
                <v-row class="py-0" style="margin-top: -8px;">
                  <v-col md="3" cols="12">
                    <v-date-input v-model="filters.from_date" label="From Date" density="compact" prepend-icon="" prepend-inner-icon="mdi-calendar-start" variant="outlined" bg-color="grey-lighten-4" autocomplete="off" clearable />
                  </v-col>
                  <v-col md="3" cols="12">
                    <v-date-input v-model="filters.to_date" label="To Date" density="compact" prepend-icon="" prepend-inner-icon="mdi-calendar-end" variant="outlined" bg-color="grey-lighten-4" autocomplete="off" clearable />
                  </v-col>
                  <v-col md="3" cols="12">
                    <div class="d-flex justify-start align-center" style="gap: 12px;">
                      <v-btn class="bg-brand w-15" type="submit" ref="searchButton" @click="loadReport">Search</v-btn>
                      <v-btn class="bg-warning w-15" type="button" prepend-icon="mdi-refresh" @click="resetFilters" title="Reset all filters and search">Reset</v-btn>
                    </div>
                  </v-col>
                  <v-col md="3" cols="12">
                    <!-- Empty space for alignment -->
                  </v-col>
                </v-row>

                <v-row class="py-2" >
                  <v-col cols="12">
                    <v-card class="pa-4">
                      <v-row>
                        <v-col md="3" cols="6">
                          <div class="text-subtitle-2">Total Employees</div>
                          <div class="text-h5">{{ summary.total_employees || 0 }}</div>
                        </v-col>
                        <v-col md="3" cols="6">
                          <div class="text-subtitle-2">Departments</div>
                          <div class="text-h5">{{ Object.keys(summary.by_department || {}).length }}</div>
                        </v-col>
                        <v-col md="3" cols="6">
                          <div class="text-subtitle-2">Designations</div>
                          <div class="text-h5">{{ Object.keys(summary.by_designation || {}).length }}</div>
                        </v-col>
                        <v-col md="3" cols="6">
                          <div class="text-subtitle-2">Employee Types</div>
                          <div class="text-h5">{{ Object.keys(summary.by_employee_type || {}).length }}</div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
                
                <v-expansion-panels v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                      Employee Summary Report List
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                <v-row class="py-1">
                  <v-col md="3" cols="12">
                    <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" single-line hide-details density="compact" variant="outlined" bg-color="grey-lighten-4" clearable />
                  </v-col>
                  <v-col md="6" cols="12">
                    <div class="d-flex justify-center">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV" :disabled="!employees.length">CSV</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel" :disabled="!employees.length">EXCEL</v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF" :disabled="!employees.length">PDF</v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <v-card class="overflow-x-auto">
                  <v-data-table :headers="headers" :items="filteredEmployees" :loading="loading" v-model:items-per-page="itemsPerPage" density="compact" class="min-w-[1200px]">
                    <template #item.index="{ index }">{{ ++index }}</template>
                    <template #item.employee_name="{ item }">
                      <div class="d-flex align-center justify-center">
                        <v-avatar size="32" class="mr-3">
                          <v-img v-if="item.image_thumb" :src="getImageUrl(item.image_thumb)" />
                          <v-icon v-else size="32" color="grey">mdi-account</v-icon>
                        </v-avatar>
                        <div class="text-center">
                          <div class="font-weight-medium">{{ item.name }}</div>
                          <div class="text-caption text-grey">{{ item.name_bangla }}</div>
                        </div>
                      </div>
                    </template>
                    <template #item.employee_code="{ item }">
                      <div class="text-center"><span class="font-weight-medium">{{ item.code }}</span></div>
                    </template>
                    <template #item.department="{ item }">
                      <div class="text-center"><span v-if="item.department" class="text-body-2">{{ item.department.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.designation="{ item }">
                      <div class="text-center"><span v-if="item.designation" class="text-body-2">{{ item.designation.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.employee_type="{ item }">
                      <div class="text-center"><span v-if="item.employee_type" class="text-body-2">{{ item.employee_type.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.section="{ item }">
                      <div class="text-center"><span v-if="item.section" class="text-body-2">{{ item.section.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.branch="{ item }">
                      <div class="text-center"><span v-if="item.branch" class="text-body-2">{{ item.branch.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.blood_group="{ item }">
                      <div class="d-flex justify-center">
                        <v-chip size="small" variant="tonal">{{ item.blood_group?.name || '-' }}</v-chip>
                      </div>
                    </template>
                    <template #item.gender="{ item }">
                      <div class="text-center"><span v-if="item.gender" class="text-body-2">{{ item.gender.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.marital_status="{ item }">
                      <div class="text-center"><span v-if="item.marital_status" class="text-body-2">{{ item.marital_status.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.religion="{ item }">
                      <div class="text-center"><span v-if="item.religion" class="text-body-2">{{ item.religion.name }}</span><span v-else class="text-grey">-</span></div>
                    </template>
                    <template #item.mobile="{ item }">
                      <div class="d-flex justify-center">
                        <div v-if="item.mobile" class="d-flex align-center"><v-icon size="12" class="mr-1" color="success">mdi-phone</v-icon><span>{{ item.mobile }}</span></div>
                        <span v-else class="text-grey">-</span>
                      </div>
                    </template>
                    <template #item.email="{ item }">
                      <div class="d-flex justify-center">
                        <div v-if="item.email" class="d-flex align-center"><v-icon size="12" class="mr-1" color="info">mdi-email</v-icon><span class="text-truncate" style="max-width: 150px;">{{ item.email }}</span></div>
                        <span v-else class="text-grey">-</span>
                      </div>
                    </template>
                    <template #item.phone_office="{ item }">
                      <div class="text-center"><span class="text-body-2">{{ item.phone_office || '-' }}</span></div>
                    </template>
                    <template #item.phone_residence="{ item }">
                      <div class="text-center"><span class="text-body-2">{{ item.phone_residence || '-' }}</span></div>
                    </template>
                    <template #item.nid="{ item }">
                      <div class="text-center"><span class="text-body-2">{{ item.nid || '-' }}</span></div>
                    </template>
                    <template #item.nationality="{ item }">
                      <div class="text-center"><span class="text-body-2">{{ item.nationality || '-' }}</span></div>
                    </template>
                    <template #item.permanent_address="{ item }">
                      <div class="text-center"><span class="text-body-2">{{ item.permanent_address || '-' }}</span></div>
                    </template>
                    <template #item.joining_date="{ item }">
                      <div class="d-flex justify-center">
                        <v-chip size="small" variant="tonal">{{ formatDate(item.joining_date) }}</v-chip>
                      </div>
                    </template>
                    <template #item.date_of_birth="{ item }">
                      <div class="d-flex justify-center">
                        <v-chip size="small" variant="tonal" color="orange">{{ formatDate(item.date_of_birth) }}</v-chip>
                      </div>
                    </template>
                    <template #item.actions="{ item }">
                      <v-btn @click="viewEmployee(item.id)" icon="mdi-eye" size="small" color="primary" variant="text" title="View Employee"></v-btn>
                    </template>
                  </v-data-table>
                </v-card>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import Axios from 'axios'
import { prefix } from '@/store/api'

const instance = getCurrentInstance()
const store = useStore()

const panel = ref([0])
const search = ref('')
const loading = ref(false)
const itemsPerPage = ref(10)
const summary = ref({})
const employees = ref([])
const departments = ref([])
const designations = ref([])
const employeeTypes = ref([])
const sections = ref([])
const genders = ref([])
const religions = ref([])
const maritalStatuses = ref([])
const bloodGroups = ref([])
const statusOptions = ref([
  { text: 'Active', value: 1 },
  { text: 'Inactive', value: 0 },
])

const filters = ref({
  department_id: null,
  designation_id: null,
  employee_type_id: null,
  section_id: null,
  gender_id: null,
  marital_status_id: null,
  religion_id: null,
  blood_group_id: null,
  status: null,
  from_date: null,
  to_date: null,
})

const headers = ref([
  { title: '#SL', key: 'index', sortable: false, align: 'center' },
  { title: 'Employee Name', key: 'employee_name', sortable: true, align: 'center' },
  { title: 'Employee ID', key: 'employee_code', sortable: true, align: 'center' },
  { title: 'Designation', key: 'designation', sortable: true, align: 'center' },
  { title: 'Department', key: 'department', sortable: true, align: 'center' },
  { title: 'Section', key: 'section', sortable: true, align: 'center' },
  { title: 'Office', key: 'phone_office', sortable: true, align: 'center' },
  { title: 'Mobile', key: 'mobile', sortable: true, align: 'center' },
  { title: 'Joining Date', key: 'joining_date', sortable: true, align: 'center' },
  { title: 'NID', key: 'nid', sortable: true, align: 'center' },
  { title: 'DOB', key: 'date_of_birth', sortable: true, align: 'center' },
  { title: 'Blood Group', key: 'blood_group', sortable: true, align: 'center' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center', width: '80px' },
])

const filteredEmployees = computed(() => {
  const all = employees.value
  const q = search.value.toLowerCase().trim()
  if (!q) return all
  return all.filter(emp => (
    (emp.name && emp.name.toLowerCase().includes(q)) ||
    (emp.code && emp.code.toLowerCase().includes(q)) ||
    (emp.department?.name && emp.department.name.toLowerCase().includes(q)) ||
    (emp.designation?.name && emp.designation.name.toLowerCase().includes(q)) ||
    (emp.employee_type?.name && emp.employee_type.name.toLowerCase().includes(q)) ||
    (emp.section?.name && emp.section.name.toLowerCase().includes(q)) ||
    (emp.gender?.name && emp.gender.name.toLowerCase().includes(q)) ||
    (emp.marital_status?.name && emp.marital_status.name.toLowerCase().includes(q)) ||
    (emp.religion?.name && emp.religion.name.toLowerCase().includes(q)) ||
    (emp.blood_group?.name && emp.blood_group.name.toLowerCase().includes(q)) ||
    (emp.date_of_birth && emp.date_of_birth.toLowerCase().includes(q))
  ))
})

const loadReport = async () => {
  loading.value = true
  try {
    const params = {
      department_id: filters.value.department_id,
      designation_id: filters.value.designation_id,
      employee_type_id: filters.value.employee_type_id,
      section_id: filters.value.section_id,
      gender_id: filters.value.gender_id,
      marital_status_id: filters.value.marital_status_id,
      religion_id: filters.value.religion_id,
      blood_group_id: filters.value.blood_group_id,
      status: filters.value.status,
      from_date: filters.value.from_date,
      to_date: filters.value.to_date,
    }
    const response = await store.dispatch('getEmployeeSummaryReport', params)
    if (response.success) {
      summary.value = response.data.summary || {}
      employees.value = response.data.employees || []
    }
  } catch (error) {
    console.error('Error loading employee summary report:', error)
  } finally {
    loading.value = false
  }
}

const loadFilters = async () => {
  try {
    const deptResponse = await Axios.get(`${prefix}hrm/get-department-list`)
    if (deptResponse.data.success) departments.value = deptResponse.data.data

    const desigResponse = await Axios.get(`${prefix}hrm/get-designation-list`)
    if (desigResponse.data.success) designations.value = desigResponse.data.data

    // Load sections
    const sectionResponse = await Axios.get(`${prefix}hrm/get-section-list`)
    if (sectionResponse.data.success) sections.value = sectionResponse.data.data

    const typeResponse = await Axios.get(`${prefix}hrm/get-employee-type-list`)
    if (typeResponse.data.success) employeeTypes.value = typeResponse.data.data

    const genderResponse = await Axios.get(`${prefix}hrm/get-gender-list`)
    if (genderResponse.data.success) genders.value = genderResponse.data.data

    const maritalResponse = await Axios.get(`${prefix}hrm/get-marital-status-list`)
    if (maritalResponse.data.success) maritalStatuses.value = maritalResponse.data.data

    const religionResponse = await Axios.get(`${prefix}hrm/get-religion-list`)
    if (religionResponse.data.success) religions.value = religionResponse.data.data

    const bloodResponse = await Axios.get(`${prefix}hrm/get-blood-group-list`)
    if (bloodResponse.data.success) bloodGroups.value = bloodResponse.data.data
  } catch (error) {
    console.error('Error loading filter data:', error)
  }
}

const getImageUrl = (path) => {
  if (!path) return ''
  return `${import.meta.env.VITE_APP_URL || ''}/${path}`
}

const viewEmployee = (employeeId) => {
  // Route must exist similar to Joining report
  window.location.hash = `#/hrm/employee-details/${employeeId}`
}

const formatDate = (date) => {
  if (!date) return '-'
  try {
    const d = new Date(date)
    return d.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
  } catch {
    return '-'
  }
}

const exportToCSV = () => {
  const data = [[
    'SL', 'Employee ID', 'Employee Name', 'Designation', 'Department', 'Section', 'Office', 'Mobile', 'Joining Date', 'NID', 'DOB', 'Blood Group'
  ]]
  employees.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.code || '-',
      item.name || '-',
      item.designation?.name || '-',
      item.department?.name || '-',
      item.section?.name || '-',
      item.phone_office || '-',
      item.mobile || '-',
      formatDate(item.joining_date),
      item.nid || '-',
      formatDate(item.date_of_birth),
      item.blood_group?.name || '-',
    ])
  })
  instance.proxy.$exportTableToCSV(data, 'employee_summary_' + instance.proxy.$fileDate())
}

const exportToExcel = () => {
  const data = [[
    'SL', 'Employee ID', 'Employee Name', 'Designation', 'Department', 'Section', 'Office', 'Mobile', 'Joining Date', 'NID', 'DOB', 'Blood Group'
  ]]
  employees.value.forEach((item, index) => {
    data.push([
      index + 1,
      item.code || '-',
      item.name || '-',
      item.designation?.name || '-',
      item.department?.name || '-',
      item.section?.name || '-',
      item.phone_office || '-',
      item.mobile || '-',
      formatDate(item.joining_date),
      item.nid || '-',
      formatDate(item.date_of_birth),
      item.blood_group?.name || '-',
    ])
  })
  instance.proxy.$exportTableToExcel(data, 'employee_summary_' + instance.proxy.$fileDate())
}

const exportToPDF = () => {
  let serialNumber = 1
  const columns = [
    'SL', 'Employee ID', 'Employee Name', 'Designation', 'Department', 'Section', 'Office', 'Mobile', 'Joining Date', 'NID', 'DOB', 'Blood Group'
  ]
  const rows = employees.value.map((item) => [
    serialNumber++,
    item.code || '-',
    item.name || '-',
    item.designation?.name || '-',
    item.department?.name || '-',
    item.section?.name || '-',
    item.phone_office || '-',
    item.mobile || '-',
    formatDate(item.joining_date),
    item.nid || '-',
    formatDate(item.date_of_birth),
    item.blood_group?.name || '-',
  ])
  instance.proxy.$exportTableToPDF(
    columns,
    rows,
    'Employee Summary Report',
    'employee_summary_' + instance.proxy.$fileDate(),
    'landscape',
    {
      styles: { fontSize: 7, cellPadding: 1 },
      headStyles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 8 },   // #
        1: { cellWidth: 18 },  // Employee ID
        2: { cellWidth: 28 },  // Employee Name
        3: { cellWidth: 22 },  // Designation
        4: { cellWidth: 20 },  // Department
        5: { cellWidth: 18 },  // Section
        6: { cellWidth: 18 },  // Office
        7: { cellWidth: 20 },  // Mobile
        8: { cellWidth: 18 },  // Joining Date
        9: { cellWidth: 26 },  // NID
        10:{ cellWidth: 18 },  // DOB
        11:{ cellWidth: 16 },  // Blood Group
      }
    }
  )
}

onMounted(() => {
  loadFilters()
  loadReport()
})

const resetFilters = () => {
  filters.value = {
    department_id: null,
    designation_id: null,
    employee_type_id: null,
    section_id: null,
    gender_id: null,
    marital_status_id: null,
    religion_id: null,
    blood_group_id: null,
    status: null,
    from_date: null,
    to_date: null,
  }
  search.value = ''
  loadReport()
}
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>


